import React from "react"
import styled from "styled-components"
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTwitter, faLine } from '@fortawesome/free-brands-svg-icons'
import { OutboundLink } from "gatsby-plugin-google-analytics"

const Container = styled.div`
    width: 250px;
    height: 50px;
    padding: 0 32px;
    border-radius: 25px;
    background-color: #232323;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    margin: 0 auto;

    @media (max-width: 550px) {
        width: 200px;
        height: 40px;
        padding: 0 8px;
    }
`;

const ShareText = styled.span`
    color: #fff;
    font-family: 'Noto Sans JP';
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.8px;
    text-align: center;
    text-transform: uppercase;
`;

const Divider = styled.span`
    width: 2px;
    height: 24px;
    background-color: #f6f6f6;
`;


const IconContainer = styled.div`
    width: 25px;
    height: 25px;
`;

const LineIcon = styled(FontAwesomeIcon)`
    color: #fff;
    transition: color 0.2s ease-in;

    &:hover {
        color: #08bf5b;
    }
`;

const TwitterIcon = styled(FontAwesomeIcon)`
    color: #fff;
    transition: color 0.2s ease-in;

    &:hover {
        color: #1da1f2;
    }
`;

const Share = ({ shareText }) => {
    // $('.share-twitter').attr('href', );
    // $('.share-line').attr('href', `http://line.me/R/msg/text/?${encodeURIComponent(title)} - ${encodeURIComponent(descriptionTwitter)}%0A${encodeURIComponent(window.location.href)}${hashtag}`);

  return (
    <Container>
        <ShareText>Share</ShareText>
        <Divider />
        <IconContainer>
            <OutboundLink target="_blank" rel="noopener noreferrer" href={`https://twitter.com/intent/tweet?lang=ja&text=${encodeURIComponent(shareText.text)}&url=${encodeURIComponent(shareText.url)}`}>
                <TwitterIcon icon={faTwitter} size="lg" color="#ffffff"/>
            </OutboundLink>
        </IconContainer>
        <IconContainer>
            <OutboundLink target="_blank" rel="noopener noreferrer" href={`http://line.me/R/msg/text/?${encodeURIComponent(shareText.text)}%0A${encodeURIComponent(shareText.url)}`}>
                <LineIcon icon={faLine} size="lg" color="#ffffff"/>
            </OutboundLink>
        </IconContainer>
    </Container>
  )
}

Share.propTypes = {
    shareText: PropTypes.object.isRequired,
};

export default Share;
